export const demo06 = {
    "sections": [
        {
            "backgroundImage": "019EJUgxJ3Uwk",
            "containers": [
                {
                    "blocks": [
                        {
                            "placeholder": "Klikk her for å skrive",
                            "text": "{\"blocks\":[{\"key\":\"9hk81\",\"text\":\"Thor Heyerdahl og Larvik\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[{\"offset\":0,\"length\":24,\"style\":\"SIZE_XL7\"},{\"offset\":0,\"length\":24,\"style\":\"color-#ffffff\"}],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                            "type": "text"
                        },
                        {
                            "placeholder": "Klikk her for å skrive",
                            "text": "{\"blocks\":[{\"key\":\"226mp\",\"text\":\"\",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{\"text-align\":\"center\"}}],\"entityMap\":{}}",
                            "type": "text"
                        }
                    ],
                    "endColumn": 7,
                    "horizontalAlign": "center",
                    "startColumn": 4
                }
            ],
            "excludeFromNav": true,
            "gradient": {
                "direction": "to bottom",
                "fromColor": "#00000080",
                "fromPercent": 0,
                "toColor": "#000000b3",
                "toPercent": 100
            },
            "order": 1,
            "templateId": 1,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJyyj"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 2,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "backgroundFocus": {
                "x": 0,
                "y": 0
            },
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJzMo"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "gridSize": "nineColumns",
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 3,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJzSH"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 4,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJzSJ"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 5,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJzSK"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 6,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundColor": "#ffffffff",
            "containers": [
                {
                    "blocks": [
                        {
                            "autoPlay": true,
                            "showControls": false,
                            "type": "video",
                            "videoUrl": "019EJWBbiJzSL"
                        }
                    ],
                    "endColumn": 8,
                    "horizontalAlign": "center",
                    "startColumn": 3
                }
            ],
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "minHeight": "100vh",
            "order": 7,
            "templateId": 2,
            "type": "content",
            "verticalAlign": "center"
        },
        {
            "backgroundImage": [
                null
            ],
            "containers": [
                {
                    "backgroundColor": "#ffffffb3",
                    "blocks": [
                        {
                            "placeholder": "Klikk her for å skrive",
                            "text": "{\"blocks\":[{\"key\":\"6ccci\",\"text\":\"Thor Heyerdahls virkeområde var \",\"type\":\"unstyled\",\"depth\":0,\"inlineStyleRanges\":[],\"entityRanges\":[],\"data\":{}}],\"entityMap\":{}}",
                            "type": "text"
                        }
                    ],
                    "borderRadius": true,
                    "endColumn": 6,
                    "horizontalAlign": "center",
                    "startColumn": 5,
                    "stepPosition": "bottom"
                }
            ],
            "gridSize": "nineColumns",
            "lock": {
                "backgroundColor": "#FFFFFF",
                "endColumn": 6,
                "horizontalAlign": "center",
                "lockedLabel": "For å scrolle videre i historien må du løse alle oppgavene",
                "startColumn": 5,
                "unlockedLabel": "Du kan scrolle videre"
            },
            "order": 8,
            "templateId": 6,
            "type": "sticky"
        }
    ],
    "settings": {
        "availableFonts": [
            "Alegreya",
            "Alegreya Sans",
            "Bebas Neue",
            "Cardo",
            "Caveat",
            "DM Sans",
            "Eczar",
            "Indie Flower",
            "Inter",
            "Lato",
            "Libre Baskerville",
            "Lora",
            "Manrope",
            "Montserrat",
            "Open Sans",
            "Oswald",
            "Permanent Marker",
            "Playfair Display",
            "Poppins",
            "PT Mono",
            "Quicksand",
            "Raleway",
            "Roboto",
            "Roboto Mono",
            "Space Mono",
            "Syne",
            "Work Sans"
        ],
        "colors": [
            {
                "key": 0,
                "value": "#000000"
            },
            {
                "key": 1,
                "value": "#000000"
            },
            {
                "key": 2,
                "value": "#000000"
            },
            {
                "key": 3,
                "value": "#000000"
            }
        ],
        "enableNav": false
    }
}